import React from 'react';
import { Typography } from '@mui/material';

interface ICasLink {
  onClick: VoidFunction;
  children: React.ReactNode;
}

const isEmpty = (children: React.ReactNode) =>
  children === null ||
  children === undefined ||
  (typeof children === 'string' && children.trim() === '');

export default function CasLink({ onClick, children }: ICasLink) {
  return (
    <Typography
      sx={{ fontSize: 'inherit', cursor: 'pointer', color: 'primary.main' }}
      onClick={onClick}
      component="span"
    >
      {isEmpty(children) ? <i>(empty)</i> : children}
    </Typography>
  );
}
